class TableGridRowController {
  constructor() {
    this.name = 'tableGridRow';
  }

  fetchMoreData(row) {
    this.options.activeCellData = row;
    this.fetchResults();
  }
  isActive(row) {
    if (this.row) {
      return row.id === this.options.activeCellData.id;
    }
  }
}

export
default TableGridRowController;


// WEBPACK FOOTER //
// ./app/components/tableGridRow/tableGridRow.controller.js